
import { toRef, computed, onMounted, PropType } from 'vue';
import {
  CouponImportResult,
  CouponsWithImageUrl,
  ValidateCouponResponse,
} from '@/lib/api/coupons.api';
import couponErrors from '@/utils/coupon-errors';
import reasonsToRefuse from '@/utils/coupons-reasons-to-refuse';

export default {
  name: 'coupon-status',
  props: {
    processed: {
      required: true,
      type: Boolean,
      default: false,
    },
    item: {
      type: Object as PropType<CouponsWithImageUrl>,
    },
    importError: {
      required: false,
      type: Object as PropType<CouponImportResult>,
    },
    validateCouponError: {
      required: false,
      type: Object as PropType<ValidateCouponResponse>,
    },
  },
  setup(props) {
    const importError = toRef(props, 'importError');
    const validateError = toRef(props, 'validateCouponError');

    const declineReason = computed(() => {
      return reasonsToRefuse
        .find((reasons) =>
          reasons.code === props.item.approval?.reason)
        .label || '';
    });

    const showError = computed(() => {
      const importSuccess = importError.value ? importError.value.success : true;
      const validateSuccess = validateError.value ? validateError.value.success : true;
      return !(importSuccess && validateSuccess);
    });
    const couponResult = computed(() => {
      return validateError.value ? validateError.value.coupon : { success: true };
    });
    const accountResult = computed(() => {
      return validateError.value ? validateError.value.account : { success: true };
    });

    onMounted(async () => {
      // validate();
    });

    const errorMessages = computed(() => {
      return importError.value
        ? importError.value.message
            .split('\\n')
            .map((line) => line.charAt(0).toUpperCase() + line.substring(1))
        : [];
    });

    return {
      errorMessages,
      validateError,
      couponResult,
      accountResult,
      showError,
      couponErrors,
      declineReason
    };
  },
};
